import { PaymentCurrencyEnum } from "./enums";

export const PaymentMethodTypes = {
  MPesa: "MPesa",
  Card: "Card",
  Bank: "Bank",
  CashiaApp: "CashiaApp",
};

export const paymentBanks = [
  {
    name: "CO-OPERATIVE BANK",
    code: "11",
    branch: "WESTLANDS",
    shortName: "CO-OP BANK",
    swiftCode: "KCOOKENA",
    beneficiary: "EMPIRE FX TRADE LIMITED",
    accounts: [
      {
        number: "01100606451003",
        currency: PaymentCurrencyEnum.KES,
      },
      {
        number: "02100606451005",
        currency: PaymentCurrencyEnum.USD,
      },
    ],
  },
];

export const MinimumDepositAmount = 50;
